import * as React from "react"
import SimpleFormat from "../../../utils/SimpleFormat";

import { RentalAdvert, RentalAdvertTranslation } from "../../../types/types";
import { render } from "react-dom";
import { defaultHeaders } from "../../Ical/api";

type Props = {
  advert: RentalAdvert
  translation: RentalAdvertTranslation
}

// =========================
// Legacy stuff, because the additional pricing logic is still done in the backend
const UpdateAdditionalPriceDetails = async (url : string) => {
  const response = await fetch(url, {
    method: "GET",
    credentials: 'same-origin',
  })

  const json = await response.json()
  document.getElementsByClassName("additional_price_details")[0].innerHTML = json.price_block
}
// =========================

// This component is for now handled by the sidebar booking block and the above promise
// Will be refactored into pure react soon...
const AdditionalPriceDetails = () => <div className="additional_price_details" />

export default class extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props)
  }

  componentDidMount() {
    UpdateAdditionalPriceDetails(this.props.advert.detailPeriodBlocksUrl)
  }

  render() {
    const pricesText = this.props.translation ? this.props.translation.pricesText : null
    return !!pricesText || this.props.advert.hasAdditionalFees ?
      <div className="box">
        <a id="additional-price-info"></a>
        <h3>
          {I18n.t('activerecord.attributes.rental_advert.prices_text')}
        </h3>
        <div>
          <div className="description">
            <SimpleFormat
              text={pricesText}
            />
          </div>
          <hr/>
          <AdditionalPriceDetails />
        </div>
      </div>
    : <></>
  }
}
